// Localized project fields (category / role / description) for FR and AR.
// English lives in src/data/projects.js and is used as-is for `en`.

const content = {
  "holm-experiences": {
    fr: {
      category: "expérience",
      role: "conception & développement web",
      description:
        "Site marketing immersif pour une marque d'hôtellerie expérientielle. Conçu et développé de A à Z, avec un accent sur le storytelling, le mouvement et un front-end rapide et responsive.",
    },
    ar: {
      category: "تجربة",
      role: "تصميم وتطوير ويب",
      description:
        "موقع تسويقي غامر لعلامة ضيافة قائمة على التجربة. صُمّم وطُوّر من الصفر مع التركيز على السرد والحركة وواجهة أمامية سريعة ومتجاوبة.",
    },
  },
  "central-avenue": {
    fr: {
      category: "immobilier",
      role: "conception & développement web",
      description:
        "Site vitrine pour un projet résidentiel haut de gamme. Présentation des biens, galerie et parcours de contact pensés pour une image soignée et premium sur tous les écrans.",
    },
    ar: {
      category: "عقار",
      role: "تصميم وتطوير ويب",
      description:
        "موقع عرض لمشروع سكني راقٍ. تقديم العقارات ومعرض الصور ومسارات الاستفسار مصمّمة لإحساس أنيق وراقٍ على جميع الشاشات.",
    },
  },
  "central-hills": {
    fr: {
      category: "immobilier",
      role: "conception & développement web",
      description:
        "Site d'atterrissage et vitrine pour un projet immobilier résidentiel. Mise en page épurée et centrée sur l'image, conçue pour convertir les visiteurs en prospects qualifiés.",
    },
    ar: {
      category: "عقار",
      role: "تصميم وتطوير ويب",
      description:
        "صفحة هبوط وموقع عرض لمشروع عقاري سكني. تصميم أنيق يعتمد على الصور، مهندَس لتحويل الزوّار إلى عملاء محتملين مؤهّلين.",
    },
  },
  "casa-beyt": {
    fr: {
      category: "immobilier",
      role: "web master & développement",
      description:
        "Plateforme immobilière présentant les projets et les annonces d'un promoteur basé à Casablanca. Conçue comme un site maintenable et piloté par le contenu.",
    },
    ar: {
      category: "عقار",
      role: "ويب ماستر وتطوير",
      description:
        "منصّة عقارية تعرض مشاريع وإعلانات مطوّر عقاري مقرّه الدار البيضاء. بُنيت كموقع قابل للصيانة ومعتمد على المحتوى.",
    },
  },
  "immo-value-capital": {
    fr: {
      category: "corporate",
      role: "conception & développement web",
      description:
        "Site corporate pour une société d'investissement immobilier. Structuré pour communiquer confiance, stratégie et portefeuille en un coup d'œil.",
    },
    ar: {
      category: "شركات",
      role: "تصميم وتطوير ويب",
      description:
        "موقع شركاتي لشركة استثمار عقاري. مُنظّم لإيصال الثقة والاستراتيجية والمحفظة في لمحة واحدة.",
    },
  },
  "green-lotus": {
    fr: {
      category: "marque",
      role: "conception & développement web",
      description:
        "Site de marque à l'identité calme et raffinée, portée par la typographie, les espacements et le mouvement. Entièrement responsive et pensé pour des mises à jour de contenu faciles.",
    },
    ar: {
      category: "علامة تجارية",
      role: "تصميم وتطوير ويب",
      description:
        "موقع علامة تجارية بهويّة هادئة ومصقولة تنعكس في الخطوط والمسافات والحركة. متجاوب بالكامل ومصمّم لتحديث المحتوى بسهولة.",
    },
  },
  "lap-electric": {
    fr: {
      category: "industriel",
      role: "conception & développement web",
      description:
        "Site corporate pour une entreprise d'ingénierie électrique. Présente les services et les projets avec un ton clair, professionnel et fiable.",
    },
    ar: {
      category: "صناعي",
      role: "تصميم وتطوير ويب",
      description:
        "موقع شركاتي لشركة هندسة كهربائية. يعرض الخدمات والمشاريع بأسلوب واضح ومهني وموثوق.",
    },
  },
  "intenda-studio": {
    fr: {
      category: "studio",
      role: "web master & développement",
      description:
        "Site du studio pour l'agence créative. Conçu pour présenter les projets, les services et l'équipe derrière le travail avec une identité forte et expressive.",
    },
    ar: {
      category: "استوديو",
      role: "ويب ماستر وتطوير",
      description:
        "موقع الاستوديو للوكالة الإبداعية. مُصمّم لعرض الأعمال والخدمات والفريق وراء المشاريع بهويّة قويّة ومعبّرة.",
    },
  },
  "az-input": {
    fr: {
      category: "digital",
      role: "conception & développement web",
      description:
        "Site de plateforme digitale à la présentation moderne et centrée produit. Conçu pour la performance et la scalabilité sur tous les appareils.",
    },
    ar: {
      category: "رقمي",
      role: "تصميم وتطوير ويب",
      description:
        "موقع منصّة رقمية بعرض حديث يركّز على المنتج. مبني للأداء وقابلية التوسّع عبر جميع الأجهزة.",
    },
  },
  "cps-top-100": {
    fr: {
      category: "événement",
      role: "web master & développement",
      description:
        "Site d'événement et de classement présentant un Top 100 sélectionné. Mise en page pilotée par les données, pensée pour une navigation rapide et un partage large.",
    },
    ar: {
      category: "فعالية",
      role: "ويب ماستر وتطوير",
      description:
        "موقع فعالية وتصنيف يعرض قائمة أفضل 100 مختارة. تصميم معتمد على البيانات، مصمّم لتصفّح سريع ومشاركة واسعة.",
    },
  },
};

// return the project with its category/role/description localized for `lang`
export const localizeProject = (project, lang) => {
  const loc = content[project.slug] && content[project.slug][lang];
  return loc ? { ...project, ...loc } : project;
};

export default content;
